module.exports = __webpack_public_path__ + "img/bahrain.7cfbaf7d.svg";